/* Auto generated by gulp-typescript-template */

export const SinglePage = `<div class="singlepage-container"><div class="SinglePage"><div view="repeat" items="[[ elements ]]" as="element" class="content-element"><div view="resolve" data="[[ element ]]"></div></div></div></div>`;
